import util from '@/libs/util.js'
import setting from '@/setting.js'

export default {
  namespaced: true,
  state: {
    // D2Admin 版本
    version: setting.releases.version
  },
  mutations: {
    /**
     * @description 显示版本信息
     * @param {Object} state vuex state
     */
    versionShow (state) {
      // util.log.capsule('D2Admin', `v${state.version}`)
      util.log.capsule('Admin', `Prototype`)
      console.log('GitLab http://git.csii.com.cn/vxu/trunk/vx-prototype3/csii.vx3.admin.cli')
    }
  }
}
